<template>
  <section class="authentication-form">
    <div class="innerpage-decor"></div>
    <div>
      <h2 class="title text-center">
        <router-link to="/">
          <img :src='"../../assets/images/efunding-logo.png"' alt="logo-brand" />
        </router-link>
      </h2>

      <div class="card" v-if="!resetSuccess && !isLoading && isTokenValid">
        <ValidationObserver v-slot="{ handleSubmit }">
          <form class="theme-form" @submit.prevent="handleSubmit(submitPassword)">
            <b-alert v-model="alert" variant="danger" dismissible>
              Terjadi Kesalahan, gagal mengubah password!
            </b-alert>
            <div class="form-group">
              <ValidationProvider name="Password baru" rules="required|confirmed:confirmation|min:8" v-slot="{ errors }">
                <input type="password" class="form-control" v-model="password" required placeholder="Isi Password baru anda" />
                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
            <div class="form-group">
              <ValidationProvider name="Konfirmasi Password" vid="confirmation" rules="required" v-slot="{ errors }">
                <input type="password" class="form-control" v-model="confpassword" placeholder="Konfirmasi Kata Sandi Baru" required />
                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
            <button type="submit" class="form-control btn-primary">Reset Password</button>
          </form>
        </ValidationObserver>
      </div>
      <div class="card" v-else-if="resetSuccess && !isLoading">
        <div class="text-center">
          <p>Berhasil mengubah password!</p>
          <router-link to="/login" class="btn btn-success mt-3">
            Login Sekarang
          </router-link>
        </div>
      </div>
      <div class="card" v-if="isLoading">
        <div class="text-center">
          <b-spinner variant="warning"></b-spinner>
        </div>
      </div>
      <div class="card" v-if="!isTokenValid && !isLoading">
        <div class="text-center">
          <p>Token tidak valid atau sudah kedaluwarsa. Silakan ulangi proses reset password.</p>
          <router-link to="/forgot-password" class="btn btn-primary">Kembali ke Lupa Password</router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import User from '../../api/user'

export default {
data() {
  return {
    isLoading: false,
    alert: false,
    resetSuccess: false,
    token: null,
    password: '',
    isTokenValid: false,
  }
},
created() {
  const token = this.$route.query.token;

  if (token) {
    this.token = token;
    this.verifyToken(token);
  } else {
    this.$router.push('/login');
  }
},
methods: {
  verifyToken(token) {
    this.isLoading = true;

    User.verifyTokenResetPassword({ token })
      .then(res => {
        // console.log('RESPONSE :', res.data);
        
        this.isLoading = false;
        if (res.data.meta.code === 200) {
          this.isTokenValid = true;
        } else {
          this.isTokenValid = false;
        }
      })
      .catch(err => {
        console.error('Error verifying token:', err);
        this.isLoading = false;
        this.isTokenValid = false;
      });
  },
  submitPassword() {
    this.isLoading = true;

    const data = {
      token: this.token,
      password: this.password,
    };

    User.resetPassword(data)
      .then(res => {
        this.isLoading = false;
        if (res.data.meta.code === 200) {
          this.resetSuccess = true;
        } else {
          this.alert = true;
        }
      })
      .catch(err => {
        console.error('Error resetting password:', err);
        this.isLoading = false;
        this.alert = true;
      });
  },
},
};
</script>



// WEBPACK FOOTER //
// src/public/auth/ResetPassword.vue